import React from 'react';
import useStyles from './styles';
import clsx from 'clsx';
import Avatar from '@material-ui/core/Avatar';
import FavoriteIcon from '@material-ui/icons/Favorite';

const MoodMeter = (props) => {
    const { meterPercent = 20, moodText = 'Mood' } = props;
    const classes = useStyles(props)

    return (
        <div className={classes.root}>
            {
                parseInt(meterPercent) >= 75 ?
                    <Avatar className={clsx(classes.avatar, classes.gray, classes.borderColor_red)}><FavoriteIcon fontSize="large" style={{ color: '#ff5768' }} /></Avatar>
                    :
                    parseInt(meterPercent) >= 50 ?
                        < Avatar className={clsx(classes.avatar, classes.gray, classes.borderColor_red)}><FavoriteIcon fontSize="large" style={{ color: '#ff5768' }} /></Avatar>
                        :
                        < Avatar className={clsx(classes.avatar, classes.gray, classes.borderColor_red)}><FavoriteIcon fontSize="large" style={{ color: '#ff5768' }} /></Avatar>
            }
            <div className={classes.progressbar_container}>
                <div className={classes.moodText}>{moodText}</div>
                {
                    parseInt(meterPercent) >= 75 ?
                        <div className={clsx(classes.progressbar, classes.gray, classes.borderColor_red)}>
                            <span style={{ width: `${meterPercent}%` }} className={clsx(classes.progress, classes.red)}></span>
                        </div>
                        :
                        parseInt(meterPercent) >= 50 ?
                            <div className={clsx(classes.progressbar, classes.gray, classes.borderColor_red)}>
                                <span style={{ width: `${meterPercent}%` }} className={clsx(classes.progress, classes.red)}></span>
                            </div>
                            :
                            <div className={clsx(classes.progressbar, classes.gray, classes.borderColor_red)}>
                                <span style={{ width: `${meterPercent}%` }} className={clsx(classes.progress, classes.red)}></span>
                            </div>
                }
            </div>
        </div >
    )
}

export default MoodMeter;